import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {TarifaOpcion} from "./tarifa-opcion.model";
import {ManagerCachingStrategy, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {TarifaTipoMaterial} from "./tarifa-tipo-material.model";
import {MetodoFabricacion} from "../materiales/metodo-fabricacion.model";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {Material} from "../materiales/material.model";
import {TipoMaterial} from "../materiales/tipo-material.model";
import {Trabajo} from "../trabajos/trabajo.model";
import {SubTrabajo} from "../trabajos/subtrabajo.model";
import {Tarifa} from "./tarifa.model";

@BasicEntity({
    name: 'Tarifa de fabricación',
    endpoint: "tarifa_fabricacions",
    isPaginated: true,
    paginationSizes: [30, 50, 100],
    type: 'TarifaFabricacion',
    managerCaching: ManagerCachingStrategy.Lazy,
    modelNameProperty: 'resumen'
})
export class TarifaFabricacion extends Tarifa{
    @BasicProperty({
        name: 'Método',
        type: PropertyType.NestedModel(MetodoFabricacion, null, NestedBehavior.SendIriOnly),
        sortable: true,
        paramName: "metodoFabricacion"
    })
    private _metodoFabricacion: MetodoFabricacion;

    @BasicProperty({
        name: 'Material',
        type: PropertyType.NestedModel(Material, null, NestedBehavior.SendIriOnly),
        sortable: true,
        paramName: "material"
    })
    private _material: Material;

    @BasicProperty({
        name: 'Acabado',
        type: PropertyType.NestedModel(TipoMaterial, null, NestedBehavior.SendIriOnly),
        nullable: true,
        sortable: true,
        paramName: "acabado"
    })
    private _acabado?: TipoMaterial;

    @BasicProperty({
        name: 'Tarifas acabados',
        type: PropertyType.NestedModel(TarifaTipoMaterial, 'tarifa', NestedBehavior.CreateOnly),
        array: true
    })
    private _tarifasAcabado?: TarifaTipoMaterial[];

    @BasicProperty({
        name: 'Trabajo',
        type: PropertyType.NestedModel(Trabajo, null, NestedBehavior.SendIriOnly),
        nullable: true,
        sortable: true,
        paramName: "trabajo"
    })
    private _trabajo?: Trabajo;

    @BasicProperty({
        name: 'SubTrabajo',
        type: PropertyType.NestedModel(SubTrabajo, null, NestedBehavior.SendIriOnly),
        nullable: true,
        sortable: true,
        paramName: "subTrabajo"
    })
    private _subTrabajo?: SubTrabajo;

    @BasicProperty({
        name: 'Opciones',
        type: PropertyType.NestedModel(TarifaOpcion, 'tarifa', NestedBehavior.CreateOnly),
        array: true
    })
    private _opciones?: TarifaOpcion[];

    @BasicProperty({
        name: 'Seleccionar tipo de conexión',
        type: PropertyType.Boolean()
    })
    private _mostrarTiposConexion: boolean = false;

    @BasicProperty({
        name: 'Es material duro',
        type: PropertyType.Boolean(),
        readWrite: ReadWrite.ReadOnly,
    })
    private _esMaterialDuro = false;

    resumen(): string {
        return `${this.metodoFabricacion} - ${this.material} - ${this.trabajo ?? ""} - ${this.subTrabajo ?? ""}`
    }

    get metodoFabricacion(): MetodoFabricacion {
        return this._metodoFabricacion;
    }

    set metodoFabricacion(value: MetodoFabricacion) {
        this._metodoFabricacion = value;
    }

    get material(): Material {
        return this._material;
    }

    set material(value: Material) {
        this._material = value;
    }

    get acabado(): TipoMaterial {
        return this._acabado;
    }

    set acabado(value: TipoMaterial) {
        this._acabado = value;
    }

    get trabajo(): Trabajo {
        return this._trabajo;
    }

    set trabajo(value: Trabajo) {
        this._trabajo = value;
    }

    get subTrabajo(): SubTrabajo {
        return this._subTrabajo;
    }

    set subTrabajo(value: SubTrabajo) {
        this._subTrabajo = value;
    }

    get opciones(): TarifaOpcion[] {
        return this._opciones;
    }

    set opciones(value: TarifaOpcion[]) {
        this._opciones = value;
    }

    get tarifasAcabado(): TarifaTipoMaterial[] {
        return this._tarifasAcabado;
    }

    set tarifasAcabado(value: TarifaTipoMaterial[]) {
        this._tarifasAcabado = value;
    }

    get mostrarTiposConexion(): boolean {
        return this._mostrarTiposConexion;
    }

    set mostrarTiposConexion(value: boolean) {
        this._mostrarTiposConexion = value;
    }

    get esMaterialDuro(): boolean {
        return this._esMaterialDuro;
    }

    set esMaterialDuro(value: boolean) {
        this._esMaterialDuro = value;
    }
}

TarifaOpcion.TARIFA_MAP.type = PropertyType.Uri(TarifaFabricacion);
TarifaTipoMaterial.TARIFA_MAP.type = PropertyType.Uri(TarifaFabricacion);
